import _get from 'lodash.get';
import Vue from 'vue';
export default {
    namespaced: true,
    state: {
        prematchData:{},
        prematchEvent:"",
        searchTeamResult:{},
        searchCompetitionResult:{},
        loadedPrematchData:false,
        loadedEventData:false,
        follow_id:"",
        prematchFavorites:[],
        competitions_rid: "",
        competitions_subid:"",
        prematch_bets_rids:[],
        prematch_bets_subids:[],
        ligas_array:[],
        prematch_event_rids: {},
        prematch_event_subids:{},
        target_event_ids:[],
        target_events_data:{},
        search_team_rid:"",
        search_competition_rid:"",
        time:"todos",
        time_loading:false,
    },
    mutations:{
        add_remove_liga(state,payload){
            let exists = false;
            state.ligas_array.forEach(item=>{
                if(payload.league == item.league){
                    state.ligas_array.splice(state.ligas_array.indexOf(item),1);
                    exists = true;
                }
            });
            if(!exists){
                state.ligas_array.push(payload);
            } 
        },
        remove_ligas(state){
            state.ligas_array = [];
        },
        setPrematchData(state, payload){
            state.prematchData = payload;
        },
        updatePrematchData(state, payload){
            var objetivo = state.prematchData;
            let updates = [];
            var missed_keys = [];
            let target = payload;
            function changes(obj){
                Object.keys(obj).forEach(value => {
                    if(obj[value] instanceof Object){
                        for(var prop in obj[value]){
                            if(prop == "id"){
                                let change = [];
                                change[obj[value][prop]] = obj[value];
                                let path = getPath(payload,obj[value][prop],obj[value]);
                                change["path"]= path;
                                updates.push(change);
                                break;
                            }
                            if(obj[value][prop] instanceof Object){
                                changes(obj[value]);
                                break;
                            }
                            else{
                                let change = [];
                                change[prop] = obj[value][prop];
                                let path = getPath(payload,prop,obj[value][prop]);
                                change["path"]= path;
                                updates.push(change);
                                obj[value][prop] = null;
                            }
                        }
                    }
                    else{
                        let change = [];
                        change[value] = obj[value];
                        let path = getPath(payload,value,obj[value]);
                        change["path"]= path;
                        updates.push(change);
                        obj[value] = null;
                    }
                });
            }
            function getPath(ob,key, value) {
                const path = [];
                const keyExists = (obj) => {
                    if (!obj || (typeof obj !== "object" && !Array.isArray(obj))) {
                        return false;
                    } else if (obj.hasOwnProperty(key) && obj[key] === value) {
                        return true;
                    } else if (Array.isArray(obj)) {
                        let parentKey = path.length ? path.pop() : "";
        
                        for (let i = 0; i < obj.length; i++) {
                            path.push(`${parentKey}[${i}]`);
                            const result = keyExists(obj[i], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    } else {
                        for (const k in obj) {
                            path.push(k);
                            const result = keyExists(obj[k], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    }
                    return false;
                };
                keyExists(ob);
                return path.join(".");
            }
            function check_path(path_array){
                let path_str = path_array.join(".");
                let result = false;
                function check(path){
                    for (let i = 0; i < path.length; i++) {
                        if(!_get(objetivo,path_str)){
                            let missed_key = path_array.pop();
                            missed_keys.unshift(missed_key);
                            result = check_path(path_array);
                            if(result){
                                break;
                            }
                        }
                        if(_get(objetivo,path_str)){
                            return path_str;
                        }
                    }
                    return result;
                }
                return check(path_array);
            }
            changes(target.data[state.competitions_subid].sport);
            updates.forEach(update => {
                missed_keys = [];
                let path_array = update.path.split(".");
                if(!(path_array.includes('data'))){
                    path_array.unshift('data');
                }
                path_array = path_array.map(n => n === state.competitions_subid || n === state.prematch_event_subid ? n = 'data': n);
                if(typeof update !== 'undefined'){
                    let key = Object.keys(update)[0];
                    let checked_path = check_path(path_array) ? check_path(path_array) : path_array.join(".");
                    if(update[key] instanceof Object){
                        try {
                            if(missed_keys.length > 0){
                                for (let index = 0; index < missed_keys.length; index++) {
                                    const missed_key = missed_keys[index];
                                    if(index == missed_keys.length - 1){
                                        Vue.set(_get(objetivo,checked_path),missed_key,Object.fromEntries([[key,update[key]]])); 
                                    }
                                    else{
                                        Vue.set(_get(objetivo,checked_path),missed_key,{}); 
                                    }
                                    checked_path += "."+missed_key;
                                }
                            }
                            else{
                                Vue.set(_get(objetivo,checked_path),key,update[key]); 
                            }
                        } catch (error) {
                            console.error(error,update,checked_path,"["+new Date().toLocaleString('en-DE')+"]");
                        }
                    }
                    else{
                        if(update[key] != null ){
                            try {
                                if(missed_keys.length > 0){
                                    for (let index = 0; index < missed_keys.length; index++) {
                                        const missed_key = missed_keys[index];
                                        if(index == missed_keys.length - 1){
                                            _get(objetivo,checked_path)[missed_key] =Object.fromEntries([[key,update[key]]]); 
                                        }
                                        else{
                                            _get(objetivo,checked_path)[missed_key] =Object.fromEntries([[missed_key,{}]]);
                                        }
                                        checked_path += "."+missed_key;
                                    }
                                }
                                else{
                                    _get(objetivo,checked_path)[key] = update[key];
                                }
                            } catch (error) {
                                console.error(error,update,checked_path,"["+new Date().toLocaleString('en-DE')+"]");
                            }
                            if(key == "current_game_state" && update[key] == "finished"){
                                path_array.pop();
                                let event_id = path_array.pop();
                                let del_path = path_array.join(".");
                                _get(objetivo,del_path)[event_id] = null;
                                if(state.follow_id != "" && update.path.includes(state.follow_id)){
                                    console.log("evento eliminado:", update,event_id);
                                } 
                            }
                        }
                        else{
                            if(!isNaN(key)){
                                try {
                                    if(missed_keys.length > 0){
                                        for (let index = 0; index < missed_keys.length; index++) {
                                            const missed_key = missed_keys[index];
                                            if(index == missed_keys.length - 1){
                                                _get(objetivo,checked_path)[missed_key] =Object.fromEntries([[key,{}]]);
                                            }
                                            else{
                                                _get(objetivo,checked_path)[missed_key] =Object.fromEntries([[missed_key,{}]]);
                                            }
                                            checked_path += "."+missed_key;
                                        }
                                    }
                                    else{
                                        _get(objetivo,checked_path)[key] = {};
                                    }
                                } catch (error) {
                                    console.error(error,update,checked_path,"["+new Date().toLocaleString('en-DE')+"]");
                                }
                            }
                        }
                    }
                    if(state.follow_id != "" && update.path.includes(state.follow_id)){
                        let today = new Date();
                        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                        console.log(update, time);
                    }
                    missed_keys = [];
                }
            });
        },
        updateEventData(state, payload){
            var objetivo = state.target_events_data[payload.game_id];
            let updates = [];
            var missed_keys = [];
            let target = payload.data;
            function changes(obj){
                Object.keys(obj).forEach(value => {
                    if(obj[value] instanceof Object){
                        for(var prop in obj[value]){
                            if(prop == "id"){
                                let change = [];
                                change[obj[value][prop]] = obj[value];
                                let path = getPath(payload,obj[value][prop],obj[value]);
                                change["path"]= path;
                                updates.push(change);
                                break;
                            }
                            if(obj[value][prop] instanceof Object){
                                changes(obj[value]);
                                break;
                            }
                            else{
                                let change = [];
                                change[prop] = obj[value][prop];
                                let path = getPath(payload,prop,obj[value][prop]);
                                change["path"]= path;
                                updates.push(change);
                                obj[value][prop] = null;
                            }
                        }
                    }
                    else{
                        let change = [];
                        change[value] = obj[value];
                        let path = getPath(payload,value,obj[value]);
                        change["path"]= path;
                        updates.push(change);
                        obj[value] = null;
                    }
                });
            }
            function getPath(ob,key, value) {
                const path = [];
                const keyExists = (obj) => {
                    if (!obj || (typeof obj !== "object" && !Array.isArray(obj))) {
                        return false;
                    } else if (obj.hasOwnProperty(key) && obj[key] === value) {
                        return true;
                    } else if (Array.isArray(obj)) {
                        let parentKey = path.length ? path.pop() : "";
        
                        for (let i = 0; i < obj.length; i++) {
                            path.push(`${parentKey}[${i}]`);
                            const result = keyExists(obj[i], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    } else {
                        for (const k in obj) {
                            path.push(k);
                            const result = keyExists(obj[k], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    }
                    return false;
                };
                keyExists(ob);
                return path.join(".");
            }
            function check_path(path_array){
                let path_str = path_array.join(".");
                let result = false;
                function check(path){
                    for (let i = 0; i < path.length; i++) {
                        if(!_get(objetivo,path_str)){
                            let missed_key = path_array.pop();
                            missed_keys.push(missed_key);
                            result = check_path(path_array);
                            if(result){
                                break;
                            }
                        }
                        if(_get(objetivo,path_str)){
                            return path_str;
                        }
                    }
                    return result;
                }
                return check(path_array);
            }
            changes(target.data[objetivo.data.subid].sport);
            updates.forEach(update => {
                let path_array = update.path.split(".");
                if(!(path_array.includes('data'))){
                    path_array.unshift('data');
                }
                path_array = path_array.map(n => n == state.competitions_subid || n == state.prematch_event_subid ? n = 'data': n);
                if(typeof update !== 'undefined'){
                    let key = Object.keys(update)[0];
                    let checked_path = check_path(path_array) ? check_path(path_array) : path_array.join(".");
                    if(update[key] instanceof Object){
                        Vue.set(_get(objetivo,checked_path),Object.keys(update)[0],update[key]); 
                    }
                    else{
                        if(update[key] != null ){
                            try {
                                if(missed_keys.length == 1){
                                    _get(objetivo,checked_path)[missed_keys[0]] =Object.fromEntries([[key,update[key]]]);
                                }
                                else{
                                    _get(objetivo,checked_path)[key] = update[key];
                                }
                                missed_keys = [];
                            } catch (error) {
                                console.error(error,update,checked_path,"["+new Date().toLocaleString('en-DE')+"]");
                            }
                            if(Object.keys(update)[0] == "current_game_state" && update[Object.keys(update)[0]] == "finished"){
                                path_array.pop();
                                let event_id = path_array.pop();
                                let del_path = path_array.join(".");
                                _get(objetivo,del_path)[event_id] = null;
                                if(state.follow_id != "" && update.path.includes(state.follow_id)){
                                    let today = new Date();
                                    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                                    console.log("evento eliminado:", update,event_id, time);
                                }
                            }
                        }
                        else{
                            if(!isNaN(Object.keys(update)[0])){
                                try {
                                    if(missed_keys.length == 1){
                                        _get(objetivo,checked_path)[missed_keys[0]] =Object.fromEntries([[key,update[key]]]);
                                    }
                                    else{
                                        _get(objetivo,checked_path)[key.toString()] = update[key];
                                    }
                                    missed_keys = [];
                                } catch (error) {
                                    console.log('error',update,checked_path);
                                }  
                            }
                        }
                    }
                    if(state.follow_id != "" && update.path.includes(state.follow_id)){
                        let today = new Date();
                        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                        console.log(update, time);
                    }
                }
            });
        },
        updateBetsData(state, payload){
            let game_id = Object.keys(payload.data.game)[0];
            let event_id = "";
            let self = this;
            state.prematch_bets_subids.forEach(item => {
                if(item.subid == payload.subid){
                    event_id = item.event_id;
                }
            });
            if(!this.getters.getBets[event_id]){return;}
            var objetivo = this.getters.getBets[event_id].game;
            let updates = [];
            var missed_keys = [];
            let target = payload.data;
            function changes(obj){
                Object.keys(obj).forEach(value => {
                    if(obj[value] instanceof Object){
                        for(var prop in obj[value]){
                            if(prop == "id"){
                                let change = [];
                                change[obj[value][prop]] = obj[value];
                                let path = getPath(payload.data,obj[value][prop],obj[value]);
                                change["path"]= path;
                                updates.push(change);
                                break;
                            }
                            if(obj[value][prop] instanceof Object){
                                changes(obj[value]);
                                break;
                            }
                            else{
                                let change = [];
                                change[prop] = obj[value][prop];
                                let path = getPath(payload.data,prop,obj[value][prop]);
                                change["path"]= path;
                                updates.push(change);
                                obj[value][prop] = null;
                                
                            }
                        }
                    }
                    else{
                        let change = [];
                        change[value] = obj[value];
                        let path = getPath(payload.data,value,obj[value]);
                        change["path"]= path;
                        updates.push(change);
                        obj[value] = null;
                    }
                });
            }
            function getPath(ob,key, value) {
                const path = [];
                const keyExists = (obj) => {
                    if (!obj || (typeof obj !== "object" && !Array.isArray(obj))) {
                        return false;
                    } else if (obj.hasOwnProperty(key) && obj[key] === value) {
                        return true;
                    } else if (Array.isArray(obj)) {
                        let parentKey = path.length ? path.pop() : "";
        
                        for (let i = 0; i < obj.length; i++) {
                            path.push(`${parentKey}[${i}]`);
                            const result = keyExists(obj[i], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    } else {
                        for (const k in obj) {
                            path.push(k);
                            const result = keyExists(obj[k], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    }
                    return false;
                };
                keyExists(ob);
                return path.join(".");
            }
            function check_path(path_array){
                let path_str = path_array.join(".");
                let result = false;
                function check(path){
                    for (let i = 0; i < path.length; i++) {
                        if(!_get(objetivo,path_str)){
                            let missed_key = path_array.pop();
                            missed_keys.push(missed_key);
                            result = check_path(path_array);
                            if(result){
                                break;
                            }
                        }
                        if(_get(objetivo,path_str)){
                            return path_str;
                        }
                    }
                    return result;
                }
                return check(path_array);
            }
            function check_block(key,value,sport,event_id){
                switch (sport) {
                    case 'Soccer':
                        let reason = self.getters.getBets[event_id].blocked_reason;
                        if(key == "current_game_time" && parseInt(value) > 84){
                            reason = "game time";
                            return true;
                        }
                        if(key == "markets_count" && parseInt(value) == 0){
                            reason = reason=="game time"?"game time":"zero markets";
                            return true;
                        }
                        if(key == "markets_count" && parseInt(value) > 0){
                            if(reason == "game time"){
                                return true;
                            }
                            reason = "";
                            return false;
                        }
                        break;
                
                    default:
                        break;
                }
                return false;
            }
            changes(target);
            updates.forEach(update => {
                let path_array = update.path.split(".");
                if(typeof update !== 'undefined'){
                    //console.log(update,payload.subid);
                    let key = Object.keys(update)[0];
                    let checked_path = check_path(path_array) ? check_path(path_array) : update.path;
                    if(update[key] instanceof Object){
                        if(update.path=="game"){
                            this.getters.getBets[event_id].blocked = false;
                            this.getters.getBets[event_id].blocked_reason = "";
                        }
                        Vue.set(_get(objetivo,checked_path),Object.keys(update)[0],update[key]); 
                    }
                    else{
                        if(update.path=="game" && update[key] == null){
                            this.getters.getBets[event_id].blocked = true;
                            this.getters.getBets[event_id].blocked_reason = "game null";
                        }
                        if(update[key] != null){
                            if(key == "current_game_time" || key == "markets_count"){
                                this.getters.getBets[event_id].blocked = check_block(Object.keys(update)[0],update[Object.keys(update)[0]],this.getters.getBets[event_id].alias,event_id);
                            }
                            if(update[key] != null ){
                                try {
                                    if(missed_keys.length == 1){
                                        _get(objetivo,checked_path)[missed_keys[0]] =Object.fromEntries([[key,update[key]]]);
                                    }
                                    else{
                                        _get(objetivo,checked_path)[key] = update[key];
                                    }
                                    missed_keys = [];
                                } catch (error) {
                                    console.error(error,update,checked_path,"["+new Date().toLocaleString('en-DE')+"]");
                                }
                                if(game_id == state.target_event_id){
                                    let obj = state.prematchEvent;
                                    let event_path = getPath(obj,'id',parseInt(game_id));
                                    let path_array_update = event_path.split(".");
                                    path_array_update.pop();
                                    path_array_update.pop();
                                    let new_path = path_array_update.join('.') +'.'+update.path;
                                    if(_get(state.prematchEvent,new_path)){
                                        _get(state.prematchEvent,new_path)[Object.keys(update)[0]] = update[Object.keys(update)[0]];
                                    }
                                    if(_get(state.prematchData,new_path)){
                                        _get(state.prematchData,new_path)[Object.keys(update)[0]] = update[Object.keys(update)[0]];
                                    }
                                }
                                else{
                                    let obj = state.prematchData;
                                    let event_path = getPath(obj,'id',parseInt(game_id));
                                    let path_array_update = event_path.split(".");
                                    path_array_update.pop();
                                    path_array_update.pop();
                                    let new_path = path_array_update.join('.') +'.'+update.path;
                                    if(_get(state.prematchData,new_path)){
                                        _get(state.prematchData,new_path)[Object.keys(update)[0]] = update[Object.keys(update)[0]];
                                    }
                                }
                            }
                            else{
                                if(!isNaN(key)){
                                    try {
                                        if(missed_keys.length == 1){
                                            _get(objetivo,checked_path)[missed_keys[0]] =Object.fromEntries([[key,update[key]]]);
                                        }
                                        else{
                                            _get(objetivo,checked_path)[key.toString()] = update[key];
                                        }
                                        missed_keys = [];
                                    } catch (error) {
                                        console.log('error',update,checked_path);
                                    }   
                                }
                            }
                        }
                        
                    }
                    if(state.follow_id != "" && update.path.includes(state.follow_id)){
                        let today = new Date();
                        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                        console.log(update, time);
                    }
                }
            });
        },
        setFollowId(state, payload){
            state.follow_id = payload;
        },
        loadedPrematchData(state, payload){
            state.loadedPrematchData = payload;
        },
        setPrematchEvent(state, payload){
            Vue.set(state.target_events_data,payload.game_id,payload.data);
        },
        request_competitions(state,payload){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            state.competitions_rid = rid;
            this.getters.getSocket.send(JSON.stringify(
                {
                    "command": "get",
                    "params": {
                        "source": "betting",
                        "what": {
                            "sport": [
                                "id",
                                "name",
                                "alias"
                            ],
                            "region": [
                                "id",
                                "name",
                                "alias",
                                "order"
                            ],
                            "competition": [
                                "id",
                                "name",
                                "order"
                            ],
                            "game": [
                                [
                                    "id",
                                    "start_ts",
                                    "team1_id",
                                    "team2_id",
                                    "team1_name",
                                    "team2_name",
                                    "team1_external_id",
                                    "team2_external_id",
                                    "type",
                                    "info",
                                    "events_count",
                                    "markets_count",
                                    "extra",
                                    "is_blocked",
                                    "game_number",
                                    "exclude_ids",
                                    "is_stat_available",
                                    "is_live",
                                    "game_external_id"
                                ]
                            ],
                            "event": [
                                "id",
                                "price",
                                "type",
                                "name",
                                "base",
                                "baseInitial",
                                "marketType"
                            ],
                            "market": [
                                "type",
                                "express_id",
                                "name",
                                "group_name"
                            ]
                        },
                        "where": {
                            "market": {
                                "@or": [
                                    {
                                        "type": {
                                            "@in": [
                                                "P1XP2",
                                                "P1P2",
                                                "1X12X2",
                                                "BothTeamsToScore",
                                                "MatchTotal",
                                                "MatchHandicap"
                                            ]
                                        }
                                    },
                                    {
                                        "@and": [
                                            {
                                                "type": {
                                                    "@in": [
                                                        "OverUnder"
                                                    ]
                                                }
                                            },
                                            {
                                                "base": {
                                                    "@in": [
                                                        2.5
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                ]
                            },
                            "game": {
                                "@or": [
                                    {
                                        "type": {
                                            "@in": [
                                                0,
                                                2
                                            ]
                                        }
                                    },
                                    {
                                        "visible_in_prematch": 1,
                                        "type": 1
                                    }
                                ],
                                "start_ts": payload
                            }
                        },
                        "subscribe": true
                    },
                    "rid": rid
                }
            ));
        },
        suscribe_event(state, payload){
            state.loadedEventData = false;
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            state.prematch_event_rids[rid] = payload;
            state.target_event_ids.push(payload);
            this.getters.getSocket.send(JSON.stringify(
                {
                    "command":"get",
                    "params":
                    {
                        "source":"betting",
                        "what":
                        {
                            "sport":["id","name","alias"],
                            "competition":["id","name"],
                            "region":["id","alias"],
                            "game":[],
                            "market":[],
                            "event":[]},
                            "where":
                            {
                                "game":
                                {
                                    "id":payload
                                }
                            },
                            "subscribe":true
                        },
                        "rid":rid
                    }
            ));
        },
        unsuscribe_event(state,payload){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            this.getters.getSocket.send(JSON.stringify(
                {"command":"unsubscribe","params":{"subid":state.prematch_event_subids[payload]},"rid":rid}
            ));
            state.target_events_data[payload] = null;
            state.prematch_event_subids[payload] = null;
            state.target_event_ids.splice(state.target_event_ids.indexOf(payload),1);
            Object.keys(state.prematch_event_rids).forEach(settleRid=>{
                if(state.prematch_event_rids[settleRid] == payload){
                    state.prematch_event_rids[settleRid] = null;
                }
            });
        },
        unsuscribe_all_events(state){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            let subids = [];
            for (const id of state.target_event_ids) {
                subids.push(state.prematch_event_subids[id]);
                state.target_events_data[id] = null;
                state.prematch_event_subids[id] = null;
            }
            this.getters.getSocket.send(JSON.stringify(
                {"command":"unsubscribe","params":{"subid":subids},"rid":rid}
            ));
            state.target_event_ids = [];
        },
        search_team(state, payload){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            state.search_team_rid = rid;
            this.getters.getSocket.send(JSON.stringify(
                {"command":"get","params":{"source":"betting","what":{"competition":[],"region":[],"game":["type","start_ts","team1_name","team2_name","id"],"sport":["id","name","alias"]},"where":{"game":{"@limit":25,"@or":[{"team1_name":{"@like":{"spa":payload}}},{"team2_name":{"@like":{"spa":payload}}}]}}},"rid":rid}
            ));
        },
        search_competition(state, payload){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            state.search_competition_rid = rid;
            this.getters.getSocket.send(JSON.stringify(
                {"command":"get","params":{"source":"betting","what":{"competition":[],"region":[],"game":["type","start_ts","team1_name","team2_name","id"],"sport":["id","name","alias"]},"where":{"competition":{"name":{"@like":{"spa":payload}}},"game":{"@limit":25}}},"rid":rid}
            ));
        },
        clear_search(state){
            state.searchCompetitionResult  = {};
            state.searchTeamResult = {};
        },
        select_time(state,payload){
            state.time = payload.name;
            state.time_loading=true;
            this.commit('prematch_2/request_competitions',payload.timer);
        },
        suscribe_odd(state, payload){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            state.prematch_bets_rids.push(rid);
            let check_odd = false;
            Object.keys(this.getters.getBets).forEach(bet=>{
                if(bet == payload.event_id && this.getters.getBets[bet]){check_odd=true;}
            })
            if(!check_odd){
                this.commit('setBets',payload);
            }
            this.getters.getSocket.send(JSON.stringify(
                {"command":"get","params":{"source":"betting","what":{"game":["id","is_blocked","last_event","team1_name","team2_name","team1_reg_name","team2_reg_name","info","match_length","text_info"],"market":["base","type","name","home_score","away_score"],"event":["id","price","type","type_1","name","base","base1","base2"]},"where":{"game":{"id":{"@in":[payload.game_id]}},"event":{"id":{"@in":[payload.event_id]}}},"subscribe":true},"rid":rid}
            ));
        },
        unsuscribe_odd(state, payload){
            let rid = "16" + Math.floor(100000000000 + Math.random() * 900000000000).toString();
            state.prematch_bets_subids.forEach(item => {
                if(item.event_id == payload){
                    this.getters.getSocket.send(JSON.stringify(
                        {"command":"unsubscribe","params":{"subid":item.subid},"rid":rid}
                    ));
                    let index = state.prematch_bets_subids.indexOf(item);
                    state.prematch_bets_subids.splice(index,1);
                    this.getters.getBets[item.event_id] = null;
                }
            });
        },
    },
    actions:{
        async setPrematchData(state, payload){
            await state.commit("setPrematchData", payload)
        },
        async add_remove_liga(state, payload){
            await state.commit("add_remove_liga", payload)
        },
        async remove_ligas(state){
            await state.commit("remove_ligas")
        },
        async updatePrematchData(state, payload){
            await state.commit("updatePrematchData", payload)
        },
        async updateEventData(state, payload){
            await state.commit("updateEventData", payload)
        },
        async setFollowId(state, payload){
            await state.commit("setFollowId", payload)
        },
        async loadedPrematchData(state, payload){
            await state.commit("loadedPrematchData", payload)
        },
        async suscribe_event(state, payload){
            await state.commit("suscribe_event", payload)
        },
        async unsuscribe_event(state,payload){
            await state.commit("unsuscribe_event",payload)
        },
        async unsuscribe_all_events(state){
            await state.commit("unsuscribe_all_events")
        },
        async search_competition(state, payload){
            await state.commit("search_competition", payload)
        },
        async search_team(state, payload){
            await state.commit("search_team", payload)
        },
        async suscribe_odd(state, payload){
            await state.commit("suscribe_odd", payload)
        },
        async unsuscribe_odd(state, payload){
            await state.commit("unsuscribe_odd", payload)
        },
        async clearSearch(state){
            await state.commit("clear_search");
        },
        async closeSocket(state){
            await state.commit("close_socket");
        },
        async select_time(state,payload){
            await state.commit("select_time",payload);
        },
        async getPrematchEvent(state,payload){
            function getPath(ob,key, value) {
                const path = [];
                const keyExists = (obj) => {
                    if (!obj || (typeof obj !== "object" && !Array.isArray(obj))) {
                        return false;
                    } else if (obj.hasOwnProperty(key) && obj[key] === value) {
                        return true;
                    } else if (Array.isArray(obj)) {
                        let parentKey = path.length ? path.pop() : "";
        
                        for (let i = 0; i < obj.length; i++) {
                            path.push(`${parentKey}[${i}]`);
                            const result = keyExists(obj[i], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    } else {
                        for (const k in obj) {
                            path.push(k);
                            const result = keyExists(obj[k], key);
                            if (result) {
                            return result;
                            }
                            path.pop();
                        }
                    }
                    return false;
                };
                keyExists(ob);
                return path.join(".");
            }
            let event_path = getPath(state.state.prematchData.data.data.sport[payload.sport_id],"id",payload.game_id);
            let event_data = _get(state.state.prematchData.data.data.sport[payload.sport_id],event_path);
            if(!event_data){
                event_data = _get(state.state.prematchData.data.data.sport[payload.sport_id].region,event_path);
            }
            if(event_path != ""){
                let pathArray = event_path.split('.');
                let liga_id = pathArray[pathArray.length-3];
                let country_id = pathArray[pathArray.length-5];
                let country_name = state.state.prematchData.data.data.sport[payload.sport_id].region[parseInt(country_id)].name;
                event_data.liga_id = parseInt(liga_id);
                event_data.country_id = parseInt(country_id);
                event_data.country = country_name
            }
            return event_data;
        },
    },
    getters:{
        getPrematchData: state => state.prematchData,
        getLigasArray: state => state.ligas_array,
        getPrematchEvent: state => state.prematchEvent,
        getFavorites: state => state.prematchFavorites,
        getPrematchLiveData: state => state.loadedPrematchData,
        getTargetEventId: state => state.target_event_id,
        getConfig: (state,getters,rootState,rootGetters) => rootGetters['getConfig'],
        getSearchTeam: state => state.searchTeamResult,
        getSearchCompetition: state => state.searchCompetitionResult,
        getLoadedEventData: state => state.loadedEventData,
        getSports: (state,getters,rootState,rootGetters) => {
            let sports = {};
            if(state.loadedPrematchData){
                let sports_banned = rootGetters['getConfig'].SkinConfig.main.hideSportsPrematch;
                Object.keys(state.prematchData.data.data.sport).forEach(sport => {
                    if(state.prematchData.data.data.sport[sport] && Object.keys(state.prematchData.data.data.sport[sport]).length>0){
                        if(!sports_banned.includes(state.prematchData.data.data.sport[sport].alias)){
                            sports[sport] = state.prematchData.data.data.sport[sport];
                        }
                    }
                });
            }
           return sports;
        },
        getSocket: (state,getters,rootState,rootGetters) => rootGetters['getSocket'],
        getSuscribeEventsMarket: state => state.target_events_data,
        getTime: state => state.time,
        getTimeLoading: state => state.time_loading,
    }
}